export const designerConstants = {
    UI_SET_DESIGNER_ACTIVE_VIEW: 'UI_SET_DESIGNER_ACTIVE_VIEW',
    UI_SET_DESIGNER_SELECTED_DOCUMENT: 'UI_SET_DESIGNER_SELECTED_DOCUMENT',
    UI_SET_DESIGNER_SHOW_PREVIEW: 'UI_SET_DESIGNER_SHOW_PREVIEW',
    UI_SET_DESIGNER_USED_CARDS: 'UI_SET_DESIGNER_USED_CARDS',
    UI_SET_DESIGNER_UNUSED_CARDS: 'UI_SET_DESIGNER_UNUSED_CARDS'
};